var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, IconButton, Typography, useTheme } from '@mui/material';
import { BubbleChatIcon, CellsIcon, DocumentAttachmentIcon } from 'hugeicons-react';
import { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { GlobalSearchModule } from '../../../../../application/common/enums/global-search-module';
import useTranslate from '../../../../../localization/helpers';
import FilterHeading from './filter-heading';
import { useSetDocumentFilterMutation } from '../../../../../application/features/chat/chat-api';
import { nanoid } from '@reduxjs/toolkit';
import { useAppSelector } from '../../../../../application/store/useStore';
var CHAT_START_LOCATION = 'Knowledge';
var KnowledgeChip = function (_a) {
    var closePopover = _a.closePopover, data = _a.data, count = _a.count, searchTerm = _a.searchTerm, isShowViewAll = _a.isShowViewAll;
    var theme = useTheme();
    var navigate = useNavigate();
    var translate = useTranslate().translate;
    var currentUser = useAppSelector(function (state) { return state.auth; }).currentUser;
    var currentCompany = useAppSelector(function (state) { return state.common; }).currentCompany;
    var _b = __read(useSetDocumentFilterMutation(), 1), setDocumentsFilter = _b[0];
    var handleClick = function () {
        closePopover && closePopover();
        navigate("/search?query=".concat(searchTerm, "&module=").concat(GlobalSearchModule.Knowledge));
    };
    var handleDetailClick = function (id) {
        closePopover && closePopover();
        navigate("/knowledge?id=".concat(id));
    };
    var startDocumentChat = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var conversation_id, documentsFilter;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    conversation_id = nanoid();
                    documentsFilter = {
                        conversation_id: conversation_id,
                        user_id: currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId,
                        user_name: currentUser === null || currentUser === void 0 ? void 0 : currentUser.name,
                        documents: [id],
                        chat_start_location: CHAT_START_LOCATION,
                        company_id: currentCompany === null || currentCompany === void 0 ? void 0 : currentCompany.id
                    };
                    return [4 /*yield*/, setDocumentsFilter(documentsFilter).unwrap()];
                case 1:
                    _a.sent();
                    closePopover && closePopover();
                    navigate('/chats');
                    return [2 /*return*/];
            }
        });
    }); };
    return count && count > 0 && data && data.length > 0 ? (_jsxs(Fragment, { children: [_jsx(FilterHeading, { heading: "".concat(count, " ").concat(translate('common.documents')), onButtonClick: function () { return handleClick(); }, isShowViewAll: isShowViewAll }), _jsx(Box, { children: data.map(function (item, index) {
                    return (_jsx(Box, { sx: { width: '100%', textAlign: 'left', borderRadius: '12px' }, children: _jsxs(Box, { display: 'flex', justifyContent: 'space-between', width: '100%', padding: '8px 12px', borderRadius: '12px', alignItems: 'center', boxShadow: theme.shadows[4], marginBottom: 1, gap: 1, children: [_jsxs(Box, { onClick: function () { return handleDetailClick(item.id); }, display: 'flex', flexDirection: 'column', width: '100%', sx: { cursor: 'pointer' }, flex: 1, minWidth: 0, children: [_jsxs(Box, { display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%', alignItems: 'center', flex: 1, minWidth: 0, gap: 1, children: [_jsx(Typography, { variant: 'body2', color: theme.palette.text.primary, dangerouslySetInnerHTML: { __html: item.modelNumber }, sx: {
                                                        whiteSpace: 'nowrap',
                                                        textOverflow: 'ellipsis',
                                                        overflow: 'hidden'
                                                    } }), _jsxs(Box, { display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1, flex: 1, minWidth: 0, children: [_jsx(Box, { flexShrink: 0, children: _jsx(DocumentAttachmentIcon, { width: '15px', height: '15px', color: theme.palette.text.disabled }) }), _jsx(Typography, { variant: 'caption', color: theme.palette.text.secondary, dangerouslySetInnerHTML: { __html: item.originalFileName }, sx: {
                                                                whiteSpace: 'nowrap',
                                                                textOverflow: 'ellipsis',
                                                                overflow: 'hidden'
                                                            } })] })] }), _jsxs(Box, { display: 'flex', flexDirection: 'row', gap: 1, width: '100%', mt: 0.5, children: [_jsx(Box, { flexShrink: 0, children: _jsx(CellsIcon, { width: '15px', height: '15px', color: theme.palette.text.disabled }) }), _jsx(Typography, { variant: 'caption', color: theme.palette.text.secondary, dangerouslySetInnerHTML: { __html: item.title }, sx: {
                                                        whiteSpace: 'nowrap',
                                                        textOverflow: 'ellipsis',
                                                        overflow: 'hidden'
                                                    } })] })] }), _jsx(Box, { borderLeft: "2px solid ".concat(theme.palette.divider), paddingLeft: 1, children: _jsx(IconButton, { sx: {
                                            border: "2px solid ".concat(theme.palette.divider),
                                            padding: 1,
                                            borderRadius: '8px'
                                        }, size: 'small', color: 'primary', onClick: function () { return startDocumentChat(item.id); }, children: _jsx(BubbleChatIcon, {}) }) })] }, index) }, index));
                }) })] })) : (_jsx(_Fragment, { children: _jsx(_Fragment, { children: _jsx(FilterHeading, { heading: "".concat(count, " ").concat(translate('common.documents')), onButtonClick: function () { return handleClick(); }, isShowViewAll: false }) }) }));
};
export default KnowledgeChip;
